module.exports = __webpack_public_path__ + "static/media/plus-icon.d33c471a.svg";